import { error, money } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const gqlQuery = gql`
  query V2ATransferDetails($input: V2ATransferDetailsInput!) {
    v2aTransferDetails(input: $input) {
      ... on V2ATransferDetailsResultSuccess {
        __typename
        confirmationMessage
        agreement {
          id
          title
          type
          resource {
            pdfDocument {
              id
              url
            }
          }
        }
        maxTransfer {
          ...money
        }
      }
      ... on V2ATransferDetailsResultError {
        ...error
      }
    }
  }
  ${error}
  ${money}
`;

export default gqlQuery;
